<script setup lang="ts">
import { useAppShellStore } from '@/store/AppShellStore'
import type { ClassSort } from '@/store/AppShellStore'

/**
 * ClassSortToggle (§04) — segmented Name / Year / Size, bound to the shared
 * classSort. Changing it reorders both the overview grid and the rail list.
 */
const appShell = useAppShellStore()
const OPTIONS: { key: ClassSort; label: string }[] = [
  { key: 'name', label: 'Name' },
  { key: 'year', label: 'Year' },
  { key: 'size', label: 'Size' },
]
</script>

<template>
  <div class="sorttoggle" role="group" aria-label="Sort classes">
    <button
      v-for="o in OPTIONS"
      :key="o.key"
      type="button"
      class="sorttoggle__seg"
      :class="{ 'sorttoggle__seg--active': appShell.classSort === o.key }"
      @click="appShell.setClassSort(o.key)"
    >
      {{ o.label }}
    </button>
  </div>
</template>

<style scoped>
.sorttoggle {
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  border-radius: var(--radius-md);
  background: var(--surface-variant);
}
.sorttoggle__seg {
  padding: 5px 14px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  cursor: pointer;
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 500;
  color: var(--ink-600);
  transition: background var(--motion-fast), color var(--motion-fast);
}
.sorttoggle__seg--active {
  background: var(--surface);
  color: var(--text-primary);
  font-weight: 600;
  box-shadow: var(--shadow-raise);
}
</style>
